export const nameValidationPattern = /^[\p{Script=Latin}\p{Mark}\d \.'\-]{1,80}$/u
